import React, { FC, memo } from 'react';
import { StyledAsterisk, StyledNote } from './styled';

const RequiredFieldText: FC = () => {
  return (
    <StyledNote>
      <StyledAsterisk>*</StyledAsterisk>indicates a required field
    </StyledNote>
  );
};

export default memo(RequiredFieldText);
